import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import { TouchBallLoading } from "react-loadingg";

import useAxios from "../../services/useAxios";

import UseFullDataContext from "../../context/UseFullData";

import ProductDetail from "./primary-tab/ProductDetail";
import Formulation from "./formulation-tab/Formulation";
import DefineAttributeComponent from "./attribute-tab";
import ToastCustomize from "../kits/ToastCustomize";
import Loader from "../../utils/Loader";
import PriceFormulation from "./price-formulation/PriceFormulation";

import { groupBy, convertFormulToShow } from "../../utils/helperFunction";
export default function Index({
  addOrEdit,
  productData,
  setProductListUpdater,
}) {
  const { productId } = useParams();
  const navigation = useNavigate();
  const { productTypeList, priceType, productListBasedOnType, productList } =
    useContext(UseFullDataContext);

  const { execute: addProductApi } = useAxios("product/create_product");
  const { execute: addPropertyApi } = useAxios(
    "product/create_product_property_link"
  );
  const { execute: getProductPropertyListApi } = useAxios(
    "product/get_product_properties"
  );
  const { execute: deactivate } = useAxios("api/Update_Product_property_links");
  const { execute: addFormulationApi } = useAxios("product/create_formulation");
  const { execute: getFormulationListApi } = useAxios(
    "api/Find_Formul_products"
  );
  const { execute: updateFormulation } = useAxios("api/Update_Formul_products");

  const [tabKeys, setTabKeys] = useState("detail-product");
  const [productStructure, setProductStructure] = useState([]);
  const [mainTypeProduct, setMainTypeProduct] = useState("-1");
  const [FirstTabData, setFirstTabData] = useState({});
  const [bodyText, setBodyText] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingFormulation, setLoadingFormulation] = useState(false);
  const [loadingProperty, setLoadingProperty] = useState(false);

  const [attributeTabData, setAttributeTabData] = useState({});
  const [attributeProductList, setAttributeProductList] = useState([]);
  const [attributeListReactSelect, setAttributeListReactSelect] = useState([]);
  const [primaryServiceList, setPrimaryServiceList] = useState([]);
  const [attributeBaseOnProduct, setAttributeBaseOnProduct] = useState([]);
  const [formulationData, setFormulationData] = useState({
    group_code: "",
    priority: "",
    product: {},
  });
  const [formulationList, setFormulationList] = useState([]);
  const [showFormulationList, setShowFormulationList] = useState([]);

  const [flag, setFlag] = useState({
    baseData: true,
    formulation: false,
    property: false,
  });

  const [productInFormulation, setProductInFormulation] = useState([]);
  const [productIDInFormulation, setProductIDInFormulation] = useState([]);
  const [formulationPrice, setFormulationPrice] = useState({ product: {} });
  const [formulationListPrice, setFormulationListPrice] = useState([]);

  // first tab handle data function
  const changeFirstTabData = (object, name) => {
    let firstTabDataTemp = FirstTabData;
    let filesListTemp = [];
    if (FirstTabData?.mainImgFiles != undefined)
      filesListTemp = [...FirstTabData?.mainImgFiles];
    if (name == "mainImgFiles") {
      object != undefined && filesListTemp.push(object);
      firstTabDataTemp = { ...firstTabDataTemp, [name]: filesListTemp };
    } else if (name == "mainImgFilesAll") {
      firstTabDataTemp = { ...firstTabDataTemp, mainImgFiles: object };
    } else {
      firstTabDataTemp =
        object != undefined
          ? { ...firstTabDataTemp, [name]: object }
          : { ...firstTabDataTemp };
    }
    setFirstTabData(firstTabDataTemp);
    if (name == "productType") {
      // reset
      let mainDataTemp = {
        title: firstTabDataTemp?.title,
        productType: firstTabDataTemp?.productType,
        description: firstTabDataTemp?.description,
        mainImg: firstTabDataTemp?.mainImg,
      };
      setFirstTabData(mainDataTemp);
      setMainTypeProduct(object?.value ?? "-1");
    }
  };
  const addProductFun = (formulationList) => {
    let temp = {
      title: FirstTabData?.title ?? "",
      description: FirstTabData?.description ?? "",
      type: FirstTabData?.productType?.value ?? "",
      cover: FirstTabData?.mainImg ?? "",
    };

    let fileObject = {};
    for (let i = 0; i < FirstTabData?.mainImgFiles?.length; i++) {
      fileObject = {
        ...fileObject,
        [`file_${i}`]: FirstTabData?.mainImgFiles[i],
      };
    }
    temp = {
      ...temp,
      link: FirstTabData?.link ?? "",
      more_description: bodyText ?? "",
      benefit_value: FirstTabData?.benefit_value ?? "",
      benefit_type: FirstTabData?.benefit_type?.value ?? "",
      discount: FirstTabData?.discount ?? "",
      discount_type: FirstTabData?.discount_type?.value ?? "",
      discount_tm: FirstTabData?.endDiscount?.unix ?? "",
      file_count: FirstTabData?.mainImgFiles?.length ?? 0,
      base_price:
        mainTypeProduct == 2 || mainTypeProduct == 3
          ? FirstTabData?.price ?? ""
          : "",
      unit:
        mainTypeProduct == 2 || mainTypeProduct == 3
          ? FirstTabData?.unit?.label ?? ""
          : "",
      file: FirstTabData?.video ?? "",
      inventory_formul:
        mainTypeProduct == 3 ? formulationList[0]?.mathPreview ?? "" : "",
      ...fileObject,
    };

    addProductApi(temp).then((result) => {
      if (result.status == 1) {
        if (result.msg != undefined && result.msg != "") {
          ToastCustomize({
            mainText: result?.msg,
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        }
        navigation(`/new-single-product/${result?.result?.id}`);
      } else if (result.msg != undefined && result.msg != "")
        ToastCustomize({
          mainText: result?.msg,
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
    });
  };
  // attribute tab handle data function
  const changeAttributeData = (object, name) => {
    let attributeTemp = attributeTabData;
    let arrayListOptionTemp = attributeTabData.arrayListOption ?? [];
    if (name == "newOption") {
      arrayListOptionTemp.push(object);
      setAttributeTabData({
        ...attributeTemp,
        arrayListOption: arrayListOptionTemp,
      });
    } else if (name == "deleteNewOption") {
      arrayListOptionTemp.splice(object, 1);
      setAttributeTabData({
        ...attributeTemp,
        arrayListOption: arrayListOptionTemp,
      });
    } else if (name == "attributeType") {
      setAttributeTabData((prev) => {
        return {
          ...prev,
          [name]: object,
          arrayListOption: [],
          minValue: "",
          maxValue: "",
        };
      });
    } else {
      setAttributeTabData((prev) => {
        return { ...prev, [name]: object };
      });
    }
  };
  const attributeDefaultData = async (update, product_id) => {
    setLoadingProperty(true);
    let array = [];
    let arraySelect = [];
    if (!flag?.property || update) {
      setFlag((prev) => {
        return { ...prev, property: true };
      });
      await getProductPropertyListApi({ product_id: product_id }).then(
        (res) => {
          array = res.result
            .map((v) => {
              return {
                ...v,
                optionsList: v.options != "" ? v.options.split(",") : [],
              };
            })
            .reverse();
          setAttributeProductList(array);
          arraySelect = res.result.map((v) => {
            return { value: v.property_id, label: v.title };
          });
          setAttributeListReactSelect(arraySelect);
          setLoadingProperty(false);
        }
      );
    }
  };

  const attributeValidation = () => {
    let validate = true;
    if (
      attributeTabData.title == "" ||
      attributeTabData?.attributeType?.value == undefined
    ) {
      ToastCustomize({
        mainText: "عنوان و نوع صفت را وارد کنید.",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      validate = false;
    } else if (
      (attributeTabData.type == 1 &&
        (attributeTabData?.minValue == "" ||
          attributeTabData?.maxValue == "")) ||
      (attributeTabData.type == 2 &&
        attributeTabData?.arrayListOption.length <= 0)
    ) {
      ToastCustomize({
        mainText: "مقادیر صفت را وارد کنید",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      validate = false;
    } else if (+attributeTabData?.maxValue < +attributeTabData.minValue) {
      ToastCustomize({
        mainText: "حداکثر ورودی نباید از حداقل کوچکتر باشد",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      validate = false;
    }
    return validate;
  };
  const deactivatePropertyFunc = (id) => {
    deactivate({ conditions: `id/=/${id}`, keyvalues: "status,-1" }).then(
      (res) => {
        if (res.status == 1) {
          attributeDefaultData(true, productId);
          ToastCustomize({
            mainText: "غیرفعال شدن صفت با موفقیت انجام شد.",
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        } else
          ToastCustomize({
            mainText: "متاسفانه مشکلی پیش آمده است لطفا مجدد تلاش کنید.",
            duration: 2000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
      }
    );
  };
  const addPropertyFunc = () => {
    if (attributeValidation()) {
      let tempPayload = {
        product_id: productId,
        min_input: attributeTabData?.minValue ?? "",
        max_input: attributeTabData?.maxValue ?? "",
        title: attributeTabData?.title ?? "",
        type: attributeTabData?.attributeType?.value ?? "",
        seen_by_user: attributeTabData?.seen_by_user ? 1 : 0,
        options: attributeTabData?.arrayListOption.join(),
        file: attributeTabData?.file ?? "",
      };
      addPropertyApi(tempPayload).then((res) => {
        if (res.status == 1) {
          setAttributeTabData({});
          if (res.msg != undefined && res.msg != "") {
            ToastCustomize({
              mainText: res?.msg,
              duration: 2000,
              toastType: "success",
              color: "success",
              position: "top-center",
              hasHeader: false,
            });
          }
          attributeDefaultData(true, productId);
        } else {
          if (res.msg != undefined && res.msg != "") {
            ToastCustomize({
              mainText: res?.msg,
              duration: 2000,
              toastType: "danger",
              color: "danger",
              position: "top-center",
              hasHeader: false,
            });
          }
        }
      });
    }
  };
  // click on formulation tab
  const FormulationDefaultData = () => {
    productListBasedOnType({ conditions: "type/in/3" });
    attributeDefaultData(true, productId);
  };
  const formulationListFunc = async (productList) => {
    setLoadingFormulation(true);
    await getFormulationListApi({
      tbl_name: "left join,made_product_conditions,id,formul_product_id",
      // conditions: `product_id/=${productId}@@status/=/0`,
    }).then((result) => {
      let resultTemp = [];
      let res = result.filter((v) => v.product_id == productId);
      let groupByMadeProductByFormulId = groupBy(res, "formul_products__id");
      let groupByMadeProductByProductId = groupBy(res, "made_from_product_id");
      let productIdList = [];
      Object.keys(groupByMadeProductByProductId).map((v, i) =>
        productIdList.push(v)
      );
      setProductIDInFormulation(productIdList);
      Object.keys(groupByMadeProductByFormulId).map((v, i) => {
        let resultTempObject = {
          formul_products__id: i,
          formuls: groupByMadeProductByFormulId[v].map((value) => {
            return {
              formul: convertFormulToShow(
                value.formul ?? "",
                attributeProductList ?? []
              ),
              propertyName:
                // attributeProductList.filter(
                attributeBaseOnProduct.filter(
                  (vv) => vv?.property_id == value?.made_product_property_id
                )[0]?.title ?? "",
            };
          }),
          made_from_product:
            productList.filter(
              (val) =>
                val.id ==
                groupByMadeProductByFormulId[v][0]?.made_from_product_id
            )[0] ?? {},
          count_val: convertFormulToShow(
            groupByMadeProductByFormulId[v][0]?.count_val ?? "",
            attributeProductList ?? []
          ),
          priority: groupByMadeProductByFormulId[v][0]?.priority,
          group_code: groupByMadeProductByFormulId[v][0]?.group_code,
          mtm: groupByMadeProductByFormulId[v][0]?.mtm,
          id: groupByMadeProductByFormulId[v][0]?.formul_products__id,
        };
        resultTemp.push(resultTempObject);
      });
      let resultTempSort = resultTemp.sort((a, b) => b.mtm - a.mtm);

      let resultTempFinal = groupBy(resultTempSort, "group_code");

      setShowFormulationList(resultTempFinal);
      setLoadingFormulation(false);
    });
  };
  const deactiveFormulation = (id, status) => {
    updateFormulation({
      conditions: `id/=/${id}`,
      keyvalues: `sttaus/=/${status}`,
    }).then((res) => {
      if (res.result == 1) {
        ToastCustomize({
          mainText: "فرمول مورد نظر با موفقیت ثبت شد.",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        formulationListFunc(primaryServiceList);
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است..",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };

  const changeFormulationData = (object, name) => {
    if (false) {
    } else {
      setFormulationData((prev) => {
        return { ...prev, [name]: object };
      });
    }
  };
  const formulationFunc = () => {
    if (!flag?.formulation) {
      setFlag((prev) => {
        return { ...prev, formulation: true };
      });
      FormulationDefaultData();
    }
  };
  const formulationValidation = () => {
    let validate = true;
    if (
      formulationData.group_code == "" ||
      formulationData.priority == "" ||
      formulationData.product.id == undefined
    ) {
      ToastCustomize({
        mainText: "محصول، الویت و کد گروه را انتخاب کنید.",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      validate = false;
    } else if (
      formulationList[0]?.mathPreview == undefined ||
      formulationList[0]?.mathPreview == ""
    ) {
      ToastCustomize({
        mainText: "فرمولها را وارد کنید.",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      validate = false;
    }
    // else if (formulationData.count_val == "" && formulationData.type == 3) {
    //   ToastCustomize({
    //     mainText: "مقدار را وارد کنید.",
    //     duration: 2000,
    //     toastType: "danger",
    //     color: "danger",
    //     position: "top-center",
    //     hasHeader: false,
    //   });
    //   validate = false;
    // }
    return validate;
  };
  const addFormulation = () => {
    let payload = {
      group_code: formulationData?.group_code ?? "",
      count_val: formulationData?.count_val ?? "",
      product_id: productId,
      made_from_product_id: formulationData?.product?.value ?? 0,
      priority: formulationData?.priority ?? "",
    };
    let formulTemp = [];
    let formulApi;
    for (let i = 0; i < formulationList.length; i++) {
      formulApi = formulationList[i]?.formulationList.map((v) => `${v.value}`);
      formulTemp.push({
        made_product_property_id: formulationList[i]?.made_product_property_id,
        formul: formulApi.join().replaceAll(",", " "),
      });
    }
    if (formulationValidation()) {
      addFormulationApi({
        ...payload,
        formuls: JSON.stringify(formulTemp),
      }).then((res) => {
        if (res.status == 1 && res.msg != "" && res.msg != undefined) {
          ToastCustomize({
            mainText: res?.msg,
            duration: 2000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
          formulationListFunc(primaryServiceList);
          resetFormulationData();
        } else if (res.status != 1 && res.msg != "" && res.msg != undefined) {
          ToastCustomize({
            mainText: res?.msg,
            duration: 2000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
    }
  };
  const resetFormulationData = () => {
    setFormulationList([]);
    setFormulationData({
      group_code: "",
      priority: "",
      product: {},
      count_val: "",
    });
  };

  // tab formulation price
  const changeHandlerFormulationPrice = (object) => {
    setFormulationPrice((prev) => ({ ...prev, ...object }));
  };
  const selectProduct = async (productData) => {
    let tempProperty = [];
    await getProductPropertyListApi({ product_id: productData.value }).then(
      (res) => {
        let arraySelect = res.result.map((v) => {
          return { value: v.property_id, label: v.title };
        });
        tempProperty = arraySelect;
      }
    );
    changeHandlerFormulationPrice({
      product: productData,
      property: tempProperty,
    });
  };

  useEffect(() => {
    setLoading(true);
    async function loadPage() {
      setMainTypeProduct(productData?.type);
      setBodyText(productData?.more_description);
      setProductStructure(productTypeList);
      setFirstTabData({
        ...productData,
        productType: productTypeList.filter(
          (v) => v.value == productData?.type
        ),
        benefit_type: priceType.filter(
          (v) => v.value == productData?.benefit_type
        ),
        discount_type: priceType.filter(
          (v) => v.value == productData?.discount_type
        ),
        endDiscount: +productData?.discount_tm * 1000,
        unit: [{ value: productData?.unit, label: productData?.unit }],
        price: productData?.base_price,
      });
      setLoading(false);
    }
    loadPage();
  }, [productData, productTypeList]);

  useEffect(() => {
    if (flag.formulation) {
      setPrimaryServiceList(productList);
      if (productList.length > 0) formulationListFunc(productList);
    }
  }, [productList]);

  useEffect(() => {
    attributeDefaultData(true, productId);
  }, []);

  useEffect(() => {
    let productListTemp = productList.filter((v) =>
      productIDInFormulation.includes(v.id)
    );
    setProductInFormulation(productListTemp);
  }, [productList, productIDInFormulation]);
  console.log("formulationPrice", formulationPrice);
  return loading ? (
    <Loader />
  ) : (
    <div className="m-3">
      <Tabs
        activeKey={tabKeys}
        id="product-definition-tabs"
        className="mb-3"
        onSelect={(key) => {
          setTabKeys(key);
          if (
            key == "formulation-product" ||
            key == "formulation-product-price"
          ) {
            formulationFunc();
          } else if (key == "attribute-product") {
            attributeDefaultData(true, productId);
          }
        }}
      >
        <Tab eventKey={"detail-product"} title={"مشخصات"}>
          <ProductDetail
            productStructure={productStructure}
            changeFirstTabData={changeFirstTabData}
            data={FirstTabData}
            mainTypeProduct={mainTypeProduct}
            addProductFunFinal={addProductFun}
            setBodyText={setBodyText}
            bodyTxt={bodyText}
            addOrEdit={addOrEdit}
            attributeProductList={attributeListReactSelect}
          />
        </Tab>
        {addOrEdit == "edit" && mainTypeProduct == "1" && (
          <Tab eventKey={"formulation-product"} title={"فرموله سازی"}>
            {/* loadingFormulation */}
            {loadingFormulation ? (
              <div className="position-relative">
                <div
                  className="position-absolute w-100 d-flex justify-content-center align-items-center"
                  style={{ height: 100 }}
                >
                  <TouchBallLoading />
                </div>
              </div>
            ) : (
              <Formulation
                primaryServiceList={primaryServiceList}
                attributeProductList={attributeProductList}
                attributeListReactSelect={attributeListReactSelect}
                addFormulation={addFormulation}
                changeFormulationData={changeFormulationData}
                data={formulationData}
                formulationList={formulationList}
                setFormulationList={setFormulationList}
                showFormulationList={showFormulationList}
                deactiveFormulation={deactiveFormulation}
                attributeDefaultData={attributeDefaultData}
                attributeBaseOnProduct={attributeBaseOnProduct}
                setAttributeBaseOnProduct={setAttributeBaseOnProduct}
              />
            )}
          </Tab>
        )}

        {addOrEdit == "edit" && mainTypeProduct == "1" && (
          <Tab
            eventKey={"formulation-product-price"}
            title={"فرموله سازی قیمت"}
          >
            {/* loadingFormulation */}
            {loadingFormulation ? (
              <div className="position-relative">
                <div
                  className="position-absolute w-100 d-flex justify-content-center align-items-center"
                  style={{ height: 100 }}
                >
                  <TouchBallLoading />
                </div>
              </div>
            ) : (
              <PriceFormulation
                productInFormulation={productInFormulation}
                data={formulationPrice}
                selectProduct={selectProduct}
                attributeProductList={attributeListReactSelect}
                formulationListPrice={formulationListPrice}
                setFormulationListPrice={setFormulationListPrice}
                changeHandlerFormulationPrice={changeHandlerFormulationPrice}
              />
            )}
          </Tab>
        )}

        {addOrEdit == "edit" &&
          (mainTypeProduct == "1" || mainTypeProduct == "3") && (
            <Tab eventKey={"attribute-product"} title={"صفتها"}>
              {loadingProperty ? (
                <div className="position-relative">
                  <div
                    className="position-absolute w-100 d-flex justify-content-center align-items-center"
                    style={{ height: 100 }}
                  >
                    <TouchBallLoading />
                  </div>
                </div>
              ) : (
                <DefineAttributeComponent
                  changeAttributeData={changeAttributeData}
                  data={{
                    ...attributeTabData,
                    inventory_formul: FirstTabData.inventory_formul,
                  }}
                  addPropertyFunc={addPropertyFunc}
                  attributeProductList={attributeProductList}
                  deactivatePropertyFunc={deactivatePropertyFunc}
                  formulationList={formulationList}
                  setFormulationList={setFormulationList}
                  attributeListReactSelect={attributeListReactSelect}
                  mainTypeProduct={mainTypeProduct}
                  setProductListUpdater={setProductListUpdater}
                />
              )}
            </Tab>
          )}
      </Tabs>
    </div>
  );
}
